import API from '@/views/Fdc/Apis'
import _ from 'lodash'

/**
 * TODO: 수정해야 할 항목 정리
 */
// FIXME: 1. save validation check 테스트
// FIXME: 2. save 후 data 조회 시 save 한 data로 select 처리 필요한지 여부 판단
// FIXME: 3. 불필요 항목 삭제
// FIXME: 4. HOST EQP 에서 Fab 변경 시 eapId 초기화
// FIXME: 5. refresh 시 우측 grid 하단 status 초기화

/**
 * Admin > Host Manager
 * Host 및 Host EQP 관리
 */
export default {
  name: 'hostManager',
  beforeMount () {
    this.initColumns()
  },
  mounted () {
    this.searchHostList()
  },
  methods: {
    /**
     * Host List grid 및 Host EQP List grid column 설정
     */
    initColumns () {
      // const useYn = ['Y', 'N']
      const status = ['RUN', 'IDLE']
      this.hostColumns = [
        { headerName: this.$t('fdc.MANAGEMENT.COLUMN.HOST_NAME'), field: 'hostName', flex: 1, required: true, modifiable: false, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.MANAGEMENT.COLUMN.HOST_TYPE'), field: 'hostType', flex: 1, required: true },
        { headerName: this.$t('fdc.MANAGEMENT.COLUMN.IP_ADDR'), field: 'ipAddr', flex: 1, required: true },
        { headerName: this.$t('fdc.MANAGEMENT.COLUMN.STATUS'), field: 'status', flex: 1, required: true, cellEditor: 'agSelectCellEditor', cellEditorParams: { values: status } }
      ]
      this.hostEqpColumns = [
        { headerName: this.$t('fdc.MANAGEMENT.COLUMN.HOST_NAME'), field: 'hostName', flex: 1, required: true, editable: false, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.FAB'), field: 'fab', flex: 1, required: true, modifiable: false, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', flex: 1, required: true, modifiable: false }
      ]
    },
    /**
    * Fab 목록 조회
    * 조회 후 grid column에 dataMap을 설정합니다.
    */
    searchFabList () {
      // fab 목록 전체. admin page 이므로 use_yn 상관 없이 가져옴.
      API.Admin.getFabsString({ useYn: 'Y' }).then((data) => {
        this.fabList = data
        this.buildSelectCellEditor(this.$refs.hostEqpGrid, this.fabList, this.hostEqpColumns, 'fab')
        // TODO: fab dropdown 생성 & eqp는 edit start 시 생성
        // let colFab = this.hostEqpGrid.columns.getColumn('fab')
        // colFab.dataMapEditor = true
        // colFab.dataMap = this.buildDataMap(this.fabList, 'fab')
      })
    },
    /**
     * BRIQUE Grid cell editing start method
     * @param {*} params 현재 row 연관 data
     */
    onCellEditingStarted (params) {
      console.log(params)
      // if (params.colDef.field === 'eqpId') {
      //   let eqpList = this.eqpList.filter(eqp => eqp.fab === params.data.fab)
      //   console.log('eqpList', eqpList)
      //   this.buildSelectCellEditor(this.$refs.hostEqpGrid, eqpList, this.hostEqpColumns, 'eqpId')
      // }
    },
    /**
     * BRIQIE Grod cell edition stop method
     */
    cellEditingStopped (params) {
      if (params.colDef.field === 'fab') {
        let eqpList = this.eqpList.filter(eqp => eqp.fab === params.data.fab)
        this.buildSelectCellEditor(this.$refs.hostEqpGrid, eqpList, this.hostEqpColumns, 'eqpId')
      }
    },
    /**
     * Host EQP에서 fab 변경 시 eqpId 초기화
     * @param {*} node rowNod
     * @param {*} rowData rowData
     * @param {*} colDef column
     */
    async onCellValueChanged (node, rowData, colDef) {
      if (colDef.field === 'fab') {
        rowData.eqpId = null
        node.setData(rowData)
      }
    },
    /**
     * EQP 목록 조회
     */
    searchEqpList () {
      let payload = { useYn: 'Y' }
      API.Admin.getEqpsString(payload).then((data) => {
        this.eqpList = data
      })
    },
    /**
     * BRIQUE Grid select cell editor 생성
     * @param {*} grid BRIQUE grid
     * @param {*} items item array
     * @param {*} columns column array
     * @param {*} keyName key name
     */
    buildSelectCellEditor (grid, items, columns, keyName) {
      if (items.length > 0) {
        let selectList = []
        items.forEach(item => {
          selectList.push(item[keyName])
        })
        columns.map(c => {
          if (c.field === keyName) {
            c.cellEditor = 'agSelectCellEditor'
            c.cellEditorParams = {
              values: selectList
            }
          }
          return c
        })
        grid.gridApi.setColumnDefs(columns)
      }
    },
    /**
     * Host 목록 조회
     */
    async searchHostList () {
      const payload = {}
      await API.Admin.getHosts(payload, this.hostCallback, [this.$refs.hostGrid])
    },
    /**
     * Host 목록 조회 callback
     * @param {*} response Host 목록 조회 결과
     */
    hostCallback (response) {
      if (response.status === 200 && response.data) {
        this.hostDataRowData = response.data
        // TODO: 좀더 고려해볼 항목
        setTimeout(() => {
          this.$refs.hostGrid.setFirstRowSelected()
        })

        this.searchFabList()
        this.searchEqpList()
      }
    },
    /**
     * Host EQP 목록 조회
     */
    async searchHostEqpList () {
      const payload = {
        hostName: this.selectedHostData.hostName
      }
      await API.Admin.getHostEqps(payload, this.hostEqpCallback, [this.$refs.hostEqpGrid])
    },
    /**
     * Host EQP 목록 조회 callback
     * @param {*} response Host EQP 목록 조회 결과
     */
    hostEqpCallback (response) {
      if (response.status === 200 && response.data) {
        this.hostEqpDataRowData = response.data
        // TODO: 좀더 고려해볼 항목
        this.$refs.hostEqpGrid.initBriquegridDisplayArea()
      }
    },
    /**
     * Host Grid refresh
     */
    refreshHostList () {
      this.$refs.hostGrid.onClickRefreshData()
    },
    /**
     * 호스트 저장 후 row 설정
     * @param {*} e focus 할 row
     */
    setHostLoadRow (e) {
      this.tmpHostSelLoadRow = {
        hostName: e.hostName
      }
    },
    /**
     * 호스트 Eqp 저장 후 row 설정
     * @param {*} e focus 할 row
     */
    setHostEqpLoadRow (e) {
      this.tmpHostEqpSelLoadRow = {
        hostName: e.hostName,
        fab: e.fab,
        eqpId: e.eqpId
      }
    },
    /**
     * Save Validation 체크 및 Data 생성
     * @param {*} grid
     * @returns {*} Validation 성공 여부, save row data, modify row data
     */
    saveValidCheck (grid) {
      // const allRows = grid.rows
      // const totalModifiedRows = grid.totalModifiedRows
      const checkedRows = grid.getCheckedRows()
      const addedRows = grid.getAddedRows()
      const updatedRows = grid.getUpdatedRows()
      let totalModifiedRows = []
      totalModifiedRows.push(...addedRows)
      totalModifiedRows.push(...updatedRows)
      let saveRows = []

      let result = {
        inValid: false,
        saveRows: saveRows,
        totalModifiedRows: totalModifiedRows
      }

      // 선택된 데이터가 없습니다.
      if (checkedRows.length < 1) {
        this.$buefy.dialog.alert(this.T.M010)
        result.inValid = true
        return result
      }

      checkedRows.some(row => {
        const rowStatus = row.briqueGridCud
        // 변경되어 선택된 저장 대상
        if (rowStatus === 'C' || rowStatus === 'U') {
          saveRows.push(row)
        }
      })

      // 변경된 데이터가 없습니다.
      if (saveRows < 1) {
        this.$buefy.dialog.alert(this.T.M011)
        result.inValid = true
        return result
      }

      if (this.saveDataValidCheck(checkedRows, grid)) {
        result.inValid = true
        return result
      }

      return result
      // 기존 로직 주석처리
      // const allRows = grid.rows
      // const checkedRows = allRows.filter(d => d.dataItem._status.checked)
      // const totalModifiedRows = grid.totalModifiedRows
      // let saveRows = []

      // let result = {
      //   inValid: false,
      //   saveRows: saveRows,
      //   totalModifiedRows: totalModifiedRows
      // }

      // // 선택된 데이터가 없습니다.
      // if (checkedRows.length < 1) {
      //   this.$buefy.dialog.alert(this.T.M010)
      //   result.inValid = true
      //   return result
      // }

      // allRows.some(row => {
      //   const rowStatus = row.dataItem._status
      //   // 변경되어 선택된 저장 대상
      //   if (rowStatus.checked && (rowStatus.added || rowStatus.modified)) {
      //     const item = _.clone(row.dataItem)
      //     delete item['_status']
      //     saveRows.push(item)
      //   }
      // })

      // // 변경된 데이터가 없습니다.
      // if (saveRows < 1) {
      //   this.$buefy.dialog.alert(this.T.M011)
      //   result.isValid = true
      //   return result
      // }

      // if (this.saveDataValidCheck(checkedRows, grid)) {
      //   result.isValid = true
      //   return result
      // }

      // return result
    },
    /**
     * 컬럼 필수 저장 값 check
     * @param {*} checkedRows check된 row data
     * @param {*} grid BRIQUE grid
     * @returns {Boolean} 체크 결과
     */
    saveDataValidCheck (checkedRows, grid) {
      // BRIQUE Grid
      const that = this
      return checkedRows.some(row => {
        const checkRequired = Object.keys(row).some(function (itemKey) {
          const column = grid.gridColumnApi.getColumn(itemKey)
          if (column != null) {
            const colDef = column.colDef
            const colValue = row[itemKey]
            if (colDef != null && colDef.required && that.isEmpty(colValue)) {
              console.log(colDef.required, colValue)
              that.tParam = [colDef.headerName]
              that.$buefy.dialog.alert(that.T.M001)
              return true
            }
          }
        })
        // 필수값
        if (checkRequired) { return true }
        // 중복값
        var dupIdx = this.rowItemDupCheck(row, grid)
        if (dupIdx > 0) {
          this.tParam = ['line : ' + dupIdx]
          this.$buefy.dialog.alert(this.T.M002)
          return true
        }
      })
      // 기존 로직 주석처리
      // const that = this
      // return checkedRows.some(row => {
      //   const checkRequired = Object.keys(row.dataItem).some(function (itemKey) {
      //     const column = grid.gridColumnsMap[itemKey]
      //     const colValue = row.dataItem[itemKey]
      //     if (column != null && column.required && that.isEmpty(colValue)) {
      //       that.tParam = [column.label]
      //       that.$buefy.dialog.alert(that.T.M001)
      //       return true
      //     }
      //   })
      //   // 필수값
      //   if (checkRequired) { return true }
      //   // 중복값
      //   var dupIdx = this.rowItemDupCheck(row.dataItem, grid)
      //   if (dupIdx > 0) {
      //     this.tParam = ['line : ' + dupIdx]
      //     this.$buefy.dialog.alert(this.T.M002)
      //     return true
      //   }
      // })
    },
    /**
     * 중복 체크
     * @param {*} item row data
     * @param {*} grid BRIQUE Grid
     * @returns {Boolean} 중복 체크 결과
     */
    rowItemDupCheck (item, grid) {
      let dupIdx = 0
      grid.getAllRows().some((row, idx) => {
        switch (grid.briqueGridId) {
          case 'BriqueGridhostGrid':
            if (this.itemHostDupCheck(item, row)) {
              dupIdx = idx + 1
              return true
            }
            break
          case 'BriqueGridhostEqpGrid':
            if (this.itemHostEqpDupCheck(item, row)) {
              dupIdx = idx + 1
              return true
            }
            break
        }
      })
      return dupIdx
    },
    /**
     * Host 중복 체크
     * @param {*} item row data (저장 항목)
     * @param {*} dataItem row data (기존 항목)
     * @returns {Boolean} 중복 체크 결과
     */
    itemHostDupCheck (item, dataItem) {
      return !_.isEqual(item, dataItem) && item.hostName === dataItem.hostName
    },
    /**
     * Host EQP 중복 체크
     * @param {*} item row data (저장 항목)
     * @param {*} dataItem row data (기존 항목)
     * @returns {Boolean} 중복 체크 결과
     */
    itemHostEqpDupCheck (item, dataItem) {
      return !_.isEqual(item, dataItem) && item.hostName === dataItem.hostName && item.fab === dataItem.fab && item.eqpId === dataItem.eqpId
    },
    /**
     * Host 저장
     */
    async saveHostData () {
      const valid = this.saveValidCheck(this.$refs.hostGrid)
      if (valid.inValid) {
        return
      }

      let confirmMessage = ''
      if (!_.isEqual(valid.saveRows.length, valid.totalModifiedRows.length)) {
        confirmMessage = this.T.M012
      }
      confirmMessage += this.T.M013
      const that = this
      let payload = {
        dataList: valid.saveRows
      }
      this.$buefy.dialog.confirm({
        message: confirmMessage,
        confirmText: this.T.B005,
        cancelText: this.T.B006,
        onConfirm: async function () {
          const responseData = await API.Admin.saveHosts(payload)
          if (responseData != null && responseData.status === 200) {
            that.$buefy.dialog.alert(that.T.M004)
            // TODO: 필요 시 추가
            // that.setHostLoadRow(valid.saveRows[0])
            that.searchHostList()
          } else {
            that.$buefy.dialog.alert(that.T.M005)
          }
        }
      })
    },
    /**
     * Host EQP 저장 (Host의 EQP)
     */
    async saveHostEqpData () {
      const valid = this.saveValidCheck(this.$refs.hostEqpGrid)
      if (valid.inValid) {
        return
      }

      let confirmMessage = ''
      if (!_.isEqual(valid.saveRows.length, valid.totalModifiedRows.length)) {
        confirmMessage = this.T.M012
      }
      confirmMessage += this.T.M013
      const that = this
      let payload = {
        dataList: valid.saveRows
      }
      this.$buefy.dialog.confirm({
        message: confirmMessage,
        confirmText: this.T.B005,
        cancelText: this.T.B006,
        onConfirm: async function () {
          const responseData = await API.Admin.saveHostEqps(payload)
          if (responseData != null && responseData.status === 200) {
            that.$buefy.dialog.alert(that.T.M004)
            // TODO: 필요 시 추가
            // that.setHostLoadRow(valid.saveRows[0])
            that.searchHostEqpList()
          } else {
            that.$buefy.dialog.alert(that.T.M005)
          }
        }
      })
    },
    /**
     * Row Data 분류
     * @param {*} grid brique grid
     * @returns {*} data Object
     * grid에 row를 분류한다. (check row, add한 row, delete row)
     */
    deleteDataCollector (grid) {
      // const allRows = grid.rows
      const checkedRows = grid.getCheckedRows()
      const addedRows = grid.getAddedRows()
      // const updatedRows = grid.getUpdatedRows()
      const deleteRows = checkedRows.filter(d => !(d.briqueGridCud === 'C') || !d.briqueGridCud)
      // let deleteRow = []
      // deleteRowWithStatus.forEach(row => {
      //   // 데이터 삭제 할 로우
      //   const item = _.clone(row.dataItem)
      //   delete item['_status']
      //   deleteRow.push(item)
      // })

      return {
        checkedRows: checkedRows,
        addedRow: addedRows,
        deleteRow: deleteRows
      }
    },
    /**
     * Host 삭제
     */
    deleteHostData () {
      const rowList = this.deleteDataCollector(this.$refs.hostGrid)
      const that = this
      if (rowList.checkedRows < 1) {
        this.$buefy.dialog.alert(this.T.M010)
      }

      const confirmMessage = this.T.M014_1 + this.T.M014
      const completeMessage = this.T.M015

      let payload = {
        dataList: rowList.deleteRow
      }

      this.$buefy.dialog.confirm({
        message: confirmMessage,
        confirmText: this.T.B005,
        cancelText: this.T.B006,
        onConfirm: async function () {
          this.hostDataRowData = []
          this.hostEqpDataRowData = []
          if (rowList.deleteRow.length > 0) {
            await API.Admin.deleteHosts(payload)
          }
          that.$buefy.dialog.alert(completeMessage)
          that.searchHostList()
        }
      })
    },
    /**
     * Host EQP 삭제 (Host의 EQP)
     */
    deleteHostEqpData () {
      const rowList = this.deleteDataCollector(this.$refs.hostEqpGrid)
      const that = this
      if (rowList.checkedRows < 1) {
        this.$buefy.dialog.alert(this.T.M010)
      }

      const confirmMessage = this.T.M014
      const completeMessage = this.T.M015

      let payload = {
        dataList: rowList.deleteRow
      }

      this.$buefy.dialog.confirm({
        message: confirmMessage,
        confirmText: this.T.B005,
        cancelText: this.T.B006,
        onConfirm: async function () {
          this.hostEqpDataRowData = []
          if (rowList.deleteRow.length > 0) {
            await API.Admin.deleteHostEqps(payload)
          }
          that.$buefy.dialog.alert(completeMessage)
          that.searchHostEqpList()
        }
      })
    },
    /**
     * Grid Cell Edit End event
     * @param {*} grid 대상 grid
     * @param {*} event 이벤트
     * 수정된 row 자동 check
     */
    async cellEditEnd (grid, event) {
      let col = grid.columns[event.col]
      let rowStatus = grid.rows[event.row]._data._status

      // modified and added row 시 자동 check (checkbox column 제외)
      if (col.binding !== '_status.checked') {
        if (rowStatus.modified || rowStatus.added) {
          rowStatus.checked = true
        } else {
          rowStatus.checked = false
        }
      }
    },
    /**
     * Host List에서 선택한 Row 설정
     * @param {*} row
     */
    setHost (row) {
      this.selectedHostData = row
      if (row != null) {
        this.searchHostEqpList()
      } else {
        this.hostEqpDataRowData = []
        // TODO: 좀더 고려해볼 항목
        this.$refs.hostEqpGrid.initBriquegridDisplayArea()
      }
    },
    /**
     *  Host List grid 신규 행 추가
     */
    hostNewRowAdd () {
      let obj = {
        hostName: '',
        hostTyp: '',
        idAddr: '',
        status: 'IDLE',
        isNew: true
      }
      this.$refs.hostGrid.addRowOne(obj)
      // let status = {
      //   checked: true,
      //   modified: false,
      //   added: true
      // }
      // this.$refs.hostGrid.addRows(arr, status)
    },
    /**
     * Host EQP List grid 신규 행 추가
     */
    hostEqpNewRowAdd () {
      let obj = {
        hostName: this.selectedHostData.hostName,
        fab: '',
        eqpId: '',
        isNew: true
      }
      this.$refs.hostEqpGrid.addRowOne(obj)
      // let status = {
      //   checked: true,
      //   modified: false,
      //   added: true
      // }
      // this.$refs.hostEqpGrid.addRows(arr, status)
    },
    /**
     * Host 선택 Row 상태 확인
     * @returns {Boolean} 선택된 row 있는지 여부
     */
    hasHostRow () {
      if (this.selectedHostData === null) {
        return false
      } else if (Object.keys(this.selectedHostData).length === 0) {
        return false
      } else if (this.selectedHostData.briqueGridCud && this.selectedHostData.briqueGridCud === 'C') {
        return false
      } else {
        return true
      }
    },
    /**
     * check된 row가 있는지 확인
     * @returns {*} check된 row 있는지 여부
     */
    hasHostCheckedRows () {
      if (!this.$refs.hostGrid) {
        return 0
      }
      return this.$refs.hostGrid.checkedRowCount > 0
    },
    /**
     * check된 row가 있는지 확인
     * @returns {*} check된 row 있는지 여부
     */
    hasHostEqpCheckedRows () {
      if (!this.$refs.hostEqpGrid) {
        return 0
      }
      return this.$refs.hostEqpGrid.checkedRowCount > 0
    },
    /**
     * BRIQUE grid selection change event
     * @param {*} rows selection rows
     */
    gridSelectionChanged (rows) {
      if (rows.length === 1) {
        var currentRow = rows[0]
        this.setHost(currentRow)
      } else {
        this.setHost(null)
      }
    },
    /**
     * null 값 check
     * @param {*} value check value
     */
    isEmpty (value) {
      if (value === '' || value === null || value === undefined || (value != null && typeof value === 'object' && !Object.keys(value).length)) {
        return true
      } else {
        return false
      }
    }
  },
  data () {
    return {
      selectedHostData: null, // 선택된 Host List grid row data
      selectedHostEqpData: null, // 선택된 Host EQP List grid row data
      hostColumns: [], // Host List grid column 배열
      hostDataRowData: [], // Host List grid row data
      hostEqpColumns: [], // Host EQP List grid column 배열
      hostEqpDataRowData: [], // Host EQP List grid row data
      defaultColDef: {
        filter: true,
        sortable: true,
        resizable: true,
        editable: true
      }, // BRIQUE Grid column default setting
      tmpHostSelLoadRow: {}, // Host List 재조회를 위한 data
      tmpHostEqpSelLoadRow: {}, // Host EQP List 재조회를 위한 data
      tParam: [], // 다국어 message parameter data
      fabList: [], // Fab 목록 배열
      eqpList: [] // EQP 목록 배열
    }
  },
  computed: {
    T: function () {
      return {
        T001: this.$t('fdc.MANAGEMENT.TITLE.T0011'),
        T002: this.$t('fdc.MANAGEMENT.TITLE.T0012'),
        B001: this.$t('fdc.COMMON.BUTTON.REFRESH'),
        B002: this.$t('fdc.COMMON.BUTTON.ADD'),
        B003: this.$t('fdc.COMMON.BUTTON.SAVE'),
        B004: this.$t('fdc.COMMON.BUTTON.DELETE'),
        B005: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        B006: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        M001: this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', this.tParam),
        M002: this.$t('fdc.COMMON.MESSAGE.INFORM_KEY_DUPLICATED', this.tParam),
        M004: this.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE'),
        M005: this.$t('fdc.COMMON.MESSAGE.FAILED_SAVE'),
        M010: this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED'),
        M011: this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_CHANGED'),
        M012: this.$t('fdc.COMMON.MESSAGE.CONFIRM_UNCHECKED_CHANGED_DATA'),
        M013: this.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE'),
        M014_1: this.$t('fdc.MANAGEMENT.MESSAGE.CONFIRM_DOWN_LEVEL_DELETE'),
        M014: this.$t('fdc.COMMON.MESSAGE.CONFIRM_DELETE'),
        M015: this.$t('fdc.COMMON.MESSAGE.SUCCEED_DELETE')
      }
    }
  }
}
